
<template>
  <n-card class="intervention-note mt-6">
    <v-row no-gutters justify="start" align="center" class="py-2 px-3">
      <v-icon>account_circle</v-icon>
      <v-col class="ml-3">
        <div class="font-weight-medium">
          <v-row no-gutters justify="center" align="center">
            {{ note.user.firstname }} {{ note.user.lastname }}
            <v-spacer />
            <v-icon
              small
              @click="openEditNote"
              v-if="canEditNote"
            >
              edit
            </v-icon>
          </v-row>
        </div>
        <div class="intervention-note-date">{{ note.$createdAt }}</div>
      </v-col>
    </v-row>
    <v-divider />
    <div class="pa-4" v-html="note.$note" v-if="!isEditing"></div>
    <template v-else>
      <v-textarea
        v-model="newComment"
        ref="noteTextarea"
        hide-details
        no-resize
        solo
        flat
        height="140"
        background-color="rgba(255, 214, 65, 0.1)"
        :disabled="isSavingNote"
      />
      <v-divider />
      <v-row no-gutters justify="end" align="center" class="ma-3">
        <v-btn small class="mr-2" tabindex="-1" text :disabled="isSavingNote" @click="isEditing = false">Annuler</v-btn>
        <v-btn small color="primary darken-1" :loading="isSavingNote" @click="updateNote">Modifier</v-btn>
      </v-row>
    </template>
  </n-card>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    isEditing: false,
    newComment: ``,
    isSavingNote: false,
  }),

  computed: {
    ...mapState(`model/user`, [`me`]),
    note() {
      const $createdAt = moment(this.value.createdAt).format(`D MMMM YYYY [à] HH[h]mm`);
      const $note = this.value.note.replace(/\r\n|\r|\n/g, `<br />`);
      return {
        ...this.value,
        $createdAt,
        $note,
      };
    },
    canEditNote() {
      return this.value.User_id === this.me.id && !this.isEditing;
    },
  },

  methods: {
    openEditNote() {
      this.newComment = this.value.note;
      this.isEditing = true;
      setTimeout(() => {
        this.$refs.noteTextarea.focus();
      }, 10);
    },
    async updateNote() {
      this.isSavingNote = true;
      const note = await this.$store.dispatch(`ui/intervention/updateNote`, {
        id: this.value.id,
        note: this.newComment,
      });
      if (note) {
        this.$emit(`updated`, note);
      }
      this.isEditing = false;
      this.isSavingNote = false;
    },
  },
};
</script>

<style lang="scss">
.intervention-note {
  position: relative;
  background-color: rgba(255, 214, 65, 0.1) !important;
  .intervention-note-date {
    font-size: 0.7rem;
    color: #777;
  }
}
</style>
